// extracted by mini-css-extract-plugin
export default {"container":"_8b3c52c5","backButtonContainer":"_4a39dc18","backArrow":"_12e3b450"};